/* CLOVEBY collection: sub-category slider + client-side filtering, sorting and pagination */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Sub-category circles: centre when they fit, slider when they don't ---------- */
  function initSubcats() {
    $$('[data-subcats]').forEach(function (wrap) {
      var track = $('[data-subcats-track]', wrap);
      var prev = $('[data-subcats-prev]', wrap), next = $('[data-subcats-next]', wrap);
      var update = function () {
        var over = track.scrollWidth > track.clientWidth + 2;
        wrap.classList.toggle('is-overflow', over);
        if (prev) prev.disabled = !over || track.scrollLeft <= 2;
        if (next) next.disabled = !over || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      var step = function (dir) { track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.7, 160), behavior: 'smooth' }); };
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    });
  }

  /* ---------- Client-side filtering ---------- */
  function initCollection() {
    var root = $('[data-cb-collection][data-client="true"]');
    if (!root) return false;
    var form = $('[data-cf-form]', root);
    var grid = $('[data-product-grid]', root);
    var items = $$('.cb-cf-item', grid);
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 20;
    var countEl = $('[data-cf-count]', root), emptyEl = $('[data-cf-empty]', root);
    var pagesEl = $('[data-cf-pages]', root), chipsEl = $('[data-cf-chips]', root), badge = $('[data-cf-badge]', root);
    var sortEl = $('[data-cf-sort]', root);
    var groups = ['cat', 'type', 'material', 'color', 'stock'];
    var state = { cat: [], type: [], material: [], color: [], stock: [], min: null, max: null, pg: 1 };

    var pr = $('[data-price-range]', form), maxP = 100;
    var MULTI = { cat: 1, color: 1 };
    var swatchMap = {};
    function toData(el) {
      (el.getAttribute('data-swatch') || '').split(';').forEach(function (pair) {
        var k = pair.indexOf('=');
        if (k > 0) { var name = pair.slice(0, k).trim(), hex = pair.slice(k + 1).trim(); if (name && hex && !swatchMap[name]) swatchMap[name] = hex; }
      });
      return { el: el, cat: el.getAttribute('data-cat') || '', type: el.getAttribute('data-type') || '', material: el.getAttribute('data-material') || '', color: el.getAttribute('data-color') || '', stock: el.getAttribute('data-stock'), price: parseFloat(el.getAttribute('data-price')) || 0 };
    }
    var data = items.map(toData);
    function has(d, g, v) { return MULTI[g] ? d[g].indexOf('|' + v + '|') > -1 : d[g] === v; }
    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

    /* Build Type / Material / Colour options + price range from the product data */
    function buildOptions() {
      var vals = { type: {}, material: {}, color: {} };
      var maxPrice = 0;
      data.forEach(function (d) {
        if (d.type) vals.type[d.type] = 1;
        if (d.material) vals.material[d.material] = 1;
        d.color.split('|').forEach(function (c) { if (c) vals.color[c] = 1; });
        if (d.price > maxPrice) maxPrice = d.price;
      });
      ['type', 'material'].forEach(function (g) {
        var box = $('[data-cf-options="' + g + '"]', form);
        if (!box) return;
        var list = Object.keys(vals[g]).sort(function (a, b) { return a.localeCompare(b); });
        box.innerHTML = list.map(function (v) {
          return '<li><label class="cb-check"><input type="checkbox" name="' + g + '" value="' + esc(v) + '"><span>' + esc(v) + ' <span class="cb-check__count" data-count-for="' + g + '::' + esc(v) + '"></span></span></label></li>';
        }).join('');
        box.closest('[data-cf-group]').hidden = list.length < (g === 'type' ? 2 : 1);
      });
      var cbox = $('[data-cf-options="color"]', form);
      if (cbox) {
        var clist = Object.keys(vals.color).sort(function (a, b) { return a.localeCompare(b); });
        cbox.innerHTML = clist.map(function (v) {
          return '<label class="cb-swatch-filter" title="' + esc(v) + '"><input type="checkbox" name="color" value="' + esc(v) + '" aria-label="' + esc(v) + '"><span style="background:' + esc(swatchMap[v] || v.toLowerCase()) + '"></span><em class="cb-swatch-filter__name">' + esc(v) + '</em></label>';
        }).join('');
        cbox.closest('[data-cf-group]').hidden = clist.length < 1;
      }
      if (pr) {
        maxP = Math.max(1, Math.ceil(maxPrice));
        pr.setAttribute('data-max', maxP);
        $$('input[type=range]', pr).forEach(function (r) { r.max = maxP; });
        var pm = $('[data-price-max]', pr); if (pm) pm.placeholder = maxP;
      }
    }

    /* Load remaining pages (collections with more than 250 products) */
    function loadMore(done) {
      var total = parseInt((($('[data-cf-pages-total]', root) || {}).getAttribute ? $('[data-cf-pages-total]', root).getAttribute('data-cf-pages-total') : '1'), 10) || 1;
      var sid = root.getAttribute('data-section-id');
      if (total <= 1 || !sid) return done();
      root.classList.add('is-loading-more');
      var base = new URLSearchParams(location.search);
      var reqs = [];
      for (var n = 2; n <= total; n++) {
        var q = new URLSearchParams();
        if (base.get('sort_by')) q.set('sort_by', base.get('sort_by'));
        q.set('page', n); q.set('section_id', sid);
        reqs.push(fetch(location.pathname + '?' + q.toString()).then(function (r) { return r.text(); }).catch(function () { return ''; }));
      }
      Promise.all(reqs).then(function (pages) {
        pages.forEach(function (html) {
          if (!html) return;
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          $$('.cb-cf-item', tmp).forEach(function (el) { el.hidden = true; grid.appendChild(el); data.push(toData(el)); });
        });
        root.classList.remove('is-loading-more');
        done();
      });
    }

    function readUrl() {
      var p = new URLSearchParams(location.search);
      groups.forEach(function (g) {
        var v = [];
        p.getAll(g).forEach(function (x) { x.split(',').forEach(function (y) { if (y) v.push(y); }); });
        state[g] = v;
      });
      state.min = p.get('min') !== null && p.get('min') !== '' ? parseFloat(p.get('min')) : null;
      state.max = p.get('max') !== null && p.get('max') !== '' ? parseFloat(p.get('max')) : null;
      state.pg = parseInt(p.get('pg'), 10) || 1;
    }
    function buildParams(extra) {
      var p = new URLSearchParams(location.search);
      groups.concat(['min', 'max', 'pg', 'page']).forEach(function (k) { p.delete(k); });
      groups.forEach(function (g) { state[g].forEach(function (v) { p.append(g, v); }); });
      if (state.min !== null) p.set('min', state.min);
      if (state.max !== null) p.set('max', state.max);
      if (state.pg > 1) p.set('pg', state.pg);
      if (extra) Object.keys(extra).forEach(function (k) { p.set(k, extra[k]); });
      return p;
    }
    function writeUrl() {
      var q = buildParams().toString();
      history.replaceState({}, '', location.pathname + (q ? '?' + q : '') + location.hash);
    }
    function syncForm() {
      $$('input[type=checkbox]', form).forEach(function (i) { i.checked = state[i.name] && state[i.name].indexOf(i.value) > -1; });
      var imin = $('[data-price-min]', form), imax = $('[data-price-max]', form);
      var rmin = $('[data-range-min]', form), rmax = $('[data-range-max]', form);
      if (imin) imin.value = state.min !== null ? state.min : '';
      if (imax) imax.value = state.max !== null ? state.max : '';
      if (rmin) rmin.value = state.min !== null ? state.min : 0;
      if (rmax) rmax.value = state.max !== null ? state.max : rmax.max;
      paintRange();
    }
    function matches(d, skip) {
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        if (g === skip) continue;
        if (!state[g].length) continue;
        if (MULTI[g]) { if (!state[g].some(function (h) { return has(d, g, h); })) return false; }
        else if (state[g].indexOf(d[g]) === -1) return false;
      }
      if (skip !== 'price') {
        if (state.min !== null && d.price < state.min) return false;
        if (state.max !== null && d.price > state.max) return false;
      }
      return true;
    }
    function updateCounts() {
      $$('[data-count-for]', form).forEach(function (el) {
        var parts = el.getAttribute('data-count-for').split('::');
        var g = parts[0], v = parts.slice(1).join('::');
        var n = data.filter(function (d) { return has(d, g, v) && matches(d, g); }).length;
        el.textContent = '(' + n + ')';
        var label = el.closest('.cb-check');
        var input = label && $('input', label);
        if (label) label.classList.toggle('is-disabled', n === 0 && !(input && input.checked));
        if (input) input.disabled = n === 0 && !input.checked;
      });
      $$('.cb-swatch-filter input', form).forEach(function (input) {
        var n = data.filter(function (d) { return has(d, 'color', input.value) && matches(d, 'color'); }).length;
        input.disabled = n === 0 && !input.checked;
        input.parentNode.classList.toggle('is-disabled', input.disabled);
        input.parentNode.title = input.value + ' (' + n + ')';
      });
    }
    function money(v) { return (root.getAttribute('data-currency') || '') + v; }
    function renderChips() {
      var html = '';
      groups.forEach(function (g) {
        state[g].forEach(function (v) {
          var label = g === 'stock' ? (v === 'in' ? 'In stock' : 'Out of stock') : v;
          if (g === 'cat') { var inp = form.querySelector('input[name=cat][value="' + v + '"]'); if (inp) label = inp.parentNode.querySelector('span').firstChild.textContent.trim(); }
          html += '<button type="button" class="cb-chip" data-chip="' + g + '" data-val="' + v.replace(/"/g, '&quot;') + '">' + label + ' <span aria-hidden="true">&times;</span></button>';
        });
      });
      if (state.min !== null || state.max !== null) {
        html += '<button type="button" class="cb-chip" data-chip="price">' + money(state.min !== null ? state.min : 0) + ' – ' + money(state.max !== null ? state.max : '∞') + ' <span aria-hidden="true">&times;</span></button>';
      }
      if (html) html += '<button type="button" class="cb-chip cb-chip--clear" data-cf-clear>Clear all</button>';
      chipsEl.innerHTML = html;
      chipsEl.hidden = !html;
      var active = groups.reduce(function (a, g) { return a + state[g].length; }, 0) + (state.min !== null || state.max !== null ? 1 : 0);
      if (badge) { badge.textContent = active; badge.hidden = !active; }
    }
    function renderPages(total) {
      var pages = Math.max(1, Math.ceil(total / perPage));
      if (pages <= 1) { pagesEl.innerHTML = ''; pagesEl.hidden = true; return; }
      pagesEl.hidden = false;
      var h = '';
      var link = function (n, label, extra) {
        var q = buildParams({ pg: n });
        if (n <= 1) q.delete('pg');
        var s = q.toString();
        return '<a href="' + location.pathname + (s ? '?' + s : '') + '" data-pg="' + n + '"' + (extra || '') + '>' + label + '</a>';
      };
      if (state.pg > 1) h += link(state.pg - 1, '&lsaquo;', ' aria-label="Previous page"');
      for (var i = 1; i <= pages; i++) {
        if (i === state.pg) h += '<span class="is-current" aria-current="page">' + i + '</span>';
        else if (i === 1 || i === pages || Math.abs(i - state.pg) <= 1) h += link(i, i);
        else if (Math.abs(i - state.pg) === 2) h += '<span>&hellip;</span>';
      }
      if (state.pg < pages) h += link(state.pg + 1, '&rsaquo;', ' aria-label="Next page"');
      pagesEl.innerHTML = h;
    }
    function updateCrumbs() {
      var crumb = $('[data-crumb-type]');
      if (crumb) {
        var one = state.type.length === 1 ? state.type[0] : '';
        crumb.hidden = !one;
        $('span', crumb).textContent = one;
      }
      $$('[data-cf-type]').forEach(function (a) { a.classList.toggle('is-active', state.type.indexOf(a.getAttribute('data-cf-type')) > -1); });
      $$('[data-cf-cat]').forEach(function (a) { a.classList.toggle('is-active', state.cat.indexOf(a.getAttribute('data-cf-cat')) > -1); });
      if (crumb && !state.type.length && state.cat.length === 1) {
        var ci = form.querySelector('input[name=cat][value="' + state.cat[0] + '"]');
        if (ci) { crumb.hidden = false; $('span', crumb).textContent = ci.parentNode.querySelector('span').firstChild.textContent.trim(); }
      }
    }
    function apply(scroll) {
      var list = data.filter(function (d) { return matches(d); });
      var pages = Math.max(1, Math.ceil(list.length / perPage));
      if (state.pg > pages) state.pg = pages;
      var start = (state.pg - 1) * perPage, end = start + perPage;
      data.forEach(function (d) { d.el.hidden = true; });
      list.forEach(function (d, i) { d.el.hidden = !(i >= start && i < end); });
      if (countEl) countEl.textContent = list.length;
      if (emptyEl) emptyEl.hidden = list.length > 0;
      grid.hidden = list.length === 0;
      updateCounts();
      renderChips();
      renderPages(list.length);
      updateCrumbs();
      writeUrl();
      if (scroll) {
        var top = root.getBoundingClientRect().top + window.scrollY - ((parseInt(getComputedStyle(document.documentElement).getPropertyValue('--cb-header-h'), 10) || 0) + 12);
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }

    /* price range */
    function paintRange() {
      if (!pr) return;
      var rmin = $('[data-range-min]', pr), rmax = $('[data-range-max]', pr), fill = $('[data-range-fill]', pr);
      var a = Math.min(+rmin.value, +rmax.value), b = Math.max(+rmin.value, +rmax.value);
      fill.style.left = (a / maxP * 100) + '%'; fill.style.width = ((b - a) / maxP * 100) + '%';
    }
    var t;
    if (pr) {
      var rmin = $('[data-range-min]', pr), rmax = $('[data-range-max]', pr), imin = $('[data-price-min]', pr), imax = $('[data-price-max]', pr);
      [rmin, rmax].forEach(function (r) {
        r.addEventListener('input', function () {
          var a = Math.min(+rmin.value, +rmax.value), b = Math.max(+rmin.value, +rmax.value);
          imin.value = a > 0 ? a : ''; imax.value = b < maxP ? b : '';
          paintRange();
        });
        r.addEventListener('change', function () {
          var a = Math.min(+rmin.value, +rmax.value), b = Math.max(+rmin.value, +rmax.value);
          state.min = a > 0 ? a : null; state.max = b < maxP ? b : null; state.pg = 1; apply();
        });
      });
      [imin, imax].forEach(function (inp) {
        inp.addEventListener('input', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            state.min = imin.value !== '' ? parseFloat(imin.value) : null;
            state.max = imax.value !== '' ? parseFloat(imax.value) : null;
            if (state.min !== null && state.max !== null && state.min > state.max) { var x = state.min; state.min = state.max; state.max = x; }
            rmin.value = state.min !== null ? state.min : 0; rmax.value = state.max !== null ? state.max : maxP;
            paintRange(); state.pg = 1; apply();
          }, 500);
        });
      });
    }

    form.addEventListener('change', function (e) {
      var i = e.target;
      if (i.type !== 'checkbox' || !state[i.name]) return;
      var arr = state[i.name], idx = arr.indexOf(i.value);
      if (i.checked && idx === -1) arr.push(i.value);
      if (!i.checked && idx > -1) arr.splice(idx, 1);
      state.pg = 1;
      apply();
    });
    function clearAll() {
      groups.forEach(function (g) { state[g] = []; });
      state.min = state.max = null; state.pg = 1;
      syncForm(); apply();
    }
    document.addEventListener('click', function (e) {
      var c = e.target.closest('[data-cf-clear]');
      if (c) { e.preventDefault(); clearAll(); return; }
      var chip = e.target.closest('[data-chip]');
      if (chip) {
        var g = chip.getAttribute('data-chip');
        if (g === 'price') { state.min = state.max = null; }
        else { var v = chip.getAttribute('data-val'); state[g] = state[g].filter(function (x) { return x !== v; }); }
        state.pg = 1; syncForm(); apply();
        return;
      }
      var pg = e.target.closest('[data-pg]');
      if (pg && root.contains(pg)) { e.preventDefault(); state.pg = parseInt(pg.getAttribute('data-pg'), 10) || 1; apply(true); return; }
      var cat = e.target.closest('[data-cf-cat]');
      if (cat) {
        e.preventDefault();
        var cv = cat.getAttribute('data-cf-cat');
        state.cat = (state.cat.length === 1 && state.cat[0] === cv) ? [] : [cv];
        state.pg = 1; syncForm(); apply(true);
        return;
      }
      var sub = e.target.closest('[data-cf-type]');
      if (sub) {
        e.preventDefault();
        var tv = sub.getAttribute('data-cf-type');
        state.type = (state.type.length === 1 && state.type[0] === tv) ? [] : [tv];
        state.pg = 1; syncForm(); apply(true);
      }
    });
    if (sortEl) sortEl.addEventListener('change', function () {
      state.pg = 1;
      var q = buildParams({ sort_by: sortEl.value });
      location.href = location.pathname + '?' + q.toString();
    });
    window.addEventListener('popstate', function () { readUrl(); syncForm(); apply(); });

    buildOptions();
    readUrl();
    syncForm();
    apply();
    loadMore(function () { buildOptions(); syncForm(); apply(); });
    return true;
  }

  function initDrawer() {
    var panel = document.getElementById('CbFilters');
    if (!panel) return;
    $$('[data-filters-close]').forEach(function (b) { b.addEventListener('click', function () { panel.classList.remove('is-open'); }); });
  }

  function boot() { initSubcats(); initCollection(); initDrawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
